import moment from 'moment';
import { Bookmark } from '../../../queries/ats/me/bookmarks/types';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { ProgramSource } from '../../../queries/ats/titles/types/sources';
import { getPercent } from '../../../utils/commonUtils';

export function getTimeStatus(program: Pick<ProgramSource, 'startTime' | 'endTime'>) {
  const now = moment();
  const start = moment(program.startTime);
  const end = moment(program.endTime);

  if (now.isBetween(start, end, 'minutes')) {
    return 'present';
  }

  if (now.isBefore(start)) {
    return 'future';
  }

  return 'past';
}

export function getProgress(bookmark: Bookmark | undefined, asset: Asset) {
  if (bookmark === undefined || typeof asset.duration !== 'number') {
    return undefined;
  }

  if (bookmark.isWatched) {
    return undefined;
  }

  return getPercent(bookmark.position, asset.duration);
}

export function isLimitedToHomeNetwork(source: ProgramSource) {
  return source.isSubscribed && source.permissions.isLimitedToHomeNetwork;
}
